import { Card, Skeleton, } from "@mui/material";
import './ProductCard.scss';
import { generateWidthByscreenSize, isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'



export const ProductCardSkeleton = () => {
    return <Card sx={{
        minWidth: 260, height: 365, width: generateWidthByscreenSize(), display: 'flex',
        flexDirection: 'column', justifyContent: 'center', margin: '5px 10px', padding: '15px'
    }}>
        <Skeleton variant="rounded" width={generateWidthByscreenSize()} height={200} />
        <Skeleton variant="text" sx={{ fontSize: '2rem', width: '113px', marginTop: '5px' }} animation="wave" />
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '224px', marginTop: '5px' }} animation="wave" />

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
            <Skeleton variant="text" sx={{ height: '25px', width: '100px' }} animation="wave" />
            <Skeleton variant="circular" width={40} height={40} />

        </div>
    </Card>
}


export const ButtonTabSkeleton = () => {

    const height = isMobile ? '30px' : '40px';
    const mobileMarginLeft = isMobile ? '20px' : null;
    const marginLeft = isIpad ? '52px' : mobileMarginLeft;

    return (

        <div style={{ display: 'flex', marginTop: '10px', marginLeft: marginLeft }}>
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '114px', margin: '5px', border: '2px solid #D4D4D4' }} />
            <Skeleton variant="rounded" sx={{ fontSize: '2rem', height: height, width: '114px', margin: '5px', border: '2px solid #D4D4D4' }} />
        </div>
    )

}